import { Navigate, useParams } from 'react-router-dom';

import { CollectionInfo } from './components/CollectionInfo';
import { Header } from './components/Header';
import { SlicesList } from './components/SlicesList';

import { AnimateSpin } from '@/components/AnimateSpin';
import { ROUTE_PATHS } from '@/config/constants';
import { useGetMerchandisingCollection } from '@/hooks/useGetMerchandisingCollection';

export function Collection() {
  const { collectionId } = useParams();

  const { merchandisingCollection, isLoading, isError } =
    useGetMerchandisingCollection(Number(collectionId));

  if (isLoading) {
    return (
      <div className="mt-10">
        <AnimateSpin />
      </div>
    );
  }

  if (isError || !merchandisingCollection) {
    return <Navigate to={ROUTE_PATHS.MERCHANDISING_COLLECTIONS} replace />;
  }

  return (
    <div className="container space-y-6 p-6">
      <Header collection={merchandisingCollection} />
      <CollectionInfo collection={merchandisingCollection} />
      <SlicesList collection={merchandisingCollection} />
    </div>
  );
}
